// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3ec50f1f","703":"b9661fee"}[chunkId] + ".chunk.js";
};